// Spotted rare acts (WI-07), synced: `act.spotted` events ({ key: 'island:act', island, actId }),
// one per person per act, recorded the first time a phone sees it (stage/WorldStage). The shelf
// shows a person's own, from any of their phones, merged with this phone's local list.

interface SpottedEvent {
  type: string
  personId?: string
  at: number
  payload: unknown
}

/** actId → first spotted (ISO), for one person on one island. */
export function spottedOn(events: readonly SpottedEvent[], personId: string | undefined, island: string): Record<string, string> {
  const out: Record<string, string> = {}
  if (!personId) return out
  for (const e of events) {
    if (e.type !== 'act.spotted' || e.personId !== personId) continue
    const p = e.payload as { island?: unknown; actId?: unknown } | null
    if (p?.island !== island || typeof p.actId !== 'string') continue
    const when = new Date(e.at).toISOString()
    if (!out[p.actId] || when < out[p.actId]!) out[p.actId] = when
  }
  return out
}
